import React from 'react';
import '../App.css';
import { useConfig } from '../context/ConfigContext';
import { useAuth } from '../context/AuthContext.jsx';
import {  useState, useEffect, useCallback } from "react";
import axios from 'axios';

function AdminDataTab() {
    const { backendApiBaseUrl} = useConfig();
    const { token } = useAuth();
    const [data, setData] = useState(null);
    const STAT_CONFIG = [
        { key: "users", label: "Users" },
        { key: "events", label: "Events" },
        { key: "morphs", label: "Morphs" },
        { key: "sketches", label: "Sketches" },

        { key: "likes", label: "Likes" },
        { key: "reactions", label: "Reactions" },
        { key: "favorites", label: "Favorites" },
        { key: "reports", label: "Reports" },
    ];


    const fetchData = useCallback(async () => {
        try {

            const fetchURL = new URL(`${backendApiBaseUrl}/admin/get/data`);
            

            const response = await axios.get(fetchURL.toString(), {
                headers: {
                    "Authorization": `Bearer ${token.token}`,
                }
            });
            setData(response.data.data);
        } catch (err) {
            console.error("Failed to fetch admin data:", err);
        }
    }, [backendApiBaseUrl, token.token]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);



    return (
        <div className="morphpagecontent">
            <div id="infiniteScrollContainer">
                <div className="container mt-5">
                    <div className="card p-4 shadow-sm border-0" style={{ backgroundColor: "#2b2d31", color: "#ffffff" }}>
                        <h1 className="text-center mb-4 border-bottom">Data Panel</h1>

                        <div className="row mt-4">
                            {STAT_CONFIG.map(({ key, label }) => (
                                <div key={key} className="col-md-3 mb-3">
                                    <div
                                        className="card text-center p-3 shadow-sm border-0"
                                        style={{ backgroundColor: "#494a4d", color: "#ffffff" }}
                                    >
                                        <div className="text-uppercase small" >{label}</div>
                                        <div className="fs-3 fw-bold" style={{ color: "#ffffff" }}>{data ? data[key] : "-"}</div>
                                    </div>
                                </div>
                            ))}
                            
                        </div>
                        <div className="d-flex justify-content-end align-items-center mt-3">
                            <button className="btn btn-outline-secondary me-2" onClick={() => fetchData()}>Refresh</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AdminDataTab;